import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { TwitterIcon, GithubIcon } from "../Svg";
// TODO GUIGUI : Update links
export var footerLinks = [];
export var socials = [
    {
        label: "Github",
        icon: GithubIcon,
        href: "https://github.com/lets-fucking-game"
    },
    {
        label: "Twitter",
        icon: TwitterIcon,
        href: "https://twitter.com/lfg_games"
    }
];
export var langs = _to_consumable_array(Array(20)).map(function(_, i) {
    return {
        code: "en".concat(i),
        language: "English".concat(i),
        locale: "Locale".concat(i)
    };
});
